import { ContentInterface } from "./../../contracts/Content.interface";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";

import { Vehicle } from "../../models/Vehicle.model";
import { DownloadCsv } from "src/app/services/download_csv.service";
import storageX from "src/app/storageCore/storageX";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { Company } from "src/app/models/Company.model";
import { getFormValidationErrors } from "src/app/helpers/validation.errors";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-clone-vehicle",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class CloneVehicleComponent implements OnInit {
  public envioLote = false;
  public btnText = "Processar";
  public btnDisabled = false;
  public axisQuantity = null;

  public vehicleForm: FormGroup;
  public veiculoTipoSelected;
  public veiculoCombustivelTipoSelected;
  public categoriaVeiculoSelected;
  public atualizarEmpresa = false;
  public empresaSelected;
  public empresaFilterSelected;

  public veiculo;
  public veiculoId: number;
  public title = "Duplicar Veículo";

  public errorMessage;
  public fuelTypes: any = [];
  public vehicleTypes: any = [];
  public companies: any = [];
  public categoriaVeiculos: any = [];
  public companiesFilter: any = [];
  public axisSelect: any = [];
  public tipoRodagemSelect: any = [];
  public cambioAutomaticoSelect: any = [];

  public cambioAutomatico: any = [
    { name: "SIM", value: true },
    { name: "NÃO", value: false },
  ];

  public companiesSelect: any = [
    { name: "Divisão", value: 1 },
    { name: "Matriz", value: 2 },
    { name: "Filial", value: 3 },
  ];

  public quantidadeEixo = [
    { name: "1 EIXO", value: 1 },
    { name: "2 EIXOS", value: 2 },
    { name: "3 EIXOS", value: 3 },
    { name: "4 EIXOS", value: 4 },
    { name: "5 EIXOS", value: 5 },
    { name: "6 EIXOS", value: 6 },
    { name: "7 EIXOS", value: 7 },
    { name: "8 EIXOS", value: 8 },
    { name: "9 EIXOS", value: 9 },
  ];

  public tipoRodagem = [
    { name: "SIMPLES", value: "S" },
    { name: "DUPLA", value: "D" },
  ];
  public errorDebug;

  uploadListener($event: any): void { }

  fncProcessar($event: any): void { }

  ngOnInit(): void {
    this.vehicleForm = this.formBuilder.group(
      {
        selecaoEmpresa: [""],
        idEmpresa: [""],
        cdPlaca: [""],
        frota: [""],
        cdRenavam: [""],
        cdChassi: [""],
        cdAntt: [""],
        cdPbt: [""],
        nmMarca: [""],
        nmModelo: [""],
        nrQuantidadeEixo: [""],
        idVeiculoTipo: ["", Validators.required],
        idVeiculoCombustivelTipo: ["", Validators.required],
        idCategoriaVeiculo: [""],
        atualizarEmpresa: [false],
        nrAnoFabricacao: [""],
        nrAnoModelo: [""],
        cdCor: [""],
        tipoRodagem: [""],
        diferencial: [""],
        serieMotor: [""],
        nmCidade: [""],
        nmEstado: [""],
        nmPais: [""],
        nrCoeficienteConsumo: [""],
        nrOdometro: [""],
        nrCapacidadeTanque: [""],
        nrTelefoneProprietario: [""],
        nmNomeProprietario: [""],
        dsEmail: [""],
        cambioAutomatico: [false],
        veiculoSensorList: this.formBuilder.array([
          this.formBuilder.group({
            id: [""],
            nrSensor: [""],
            cdPosicaoPneu: [""],
            cdSensor: [""],
            nrPressaoMinima: [""],
            nrPressaoMaxima: [""],
            nrTemperaturaMaxima: [""],
          }),
        ]),
      },
      { updateOn: "blur" }
    );

    this.veiculoId = this.activatedRoute.snapshot.params["id"];
    this.loadVeiculo(this.veiculoId);

    this.veiculoSensorItems.removeAt(0);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async searchPlate() {
    this.spinner.show();
    let placa = this.vehicleForm.get('cdPlaca')?.value;

    console.log(placa)
    const apiUrl = `https://placas.fipeapi.com.br/placas/${placa}?key=${environment.apiKeyFipe}`;
    this.http.get(apiUrl).subscribe(
      (response: any) => {
        console.log('Dados da API FIPE:', response);
        if (response?.data?.veiculo) {
          this.fillForm(response.data.veiculo);
          this.spinner.hide();
        }
        this.spinner.hide();
      },
      (error) => {
        console.error('Erro ao buscar dados da placa:', error);
        this.spinner.hide();
      }
    );
  }

  fillForm(veiculo: any) {
    // Extrair "ano" e separar em fabricação e modelo
    const [anoFabricacao, anoModelo] = veiculo.ano.split('/');

    // Extrair "marca_modelo" e separar em marca e modelo
    const [marca, modelo] = veiculo.marca_modelo.split('/');

    // Preencher os campos do formulário
    this.vehicleForm.patchValue({
      nmEstado: veiculo.uf,  // Estado (UF)
      nrAnoFabricacao: anoFabricacao,  // Ano de Fabricação
      nrAnoModelo: anoModelo,  // Ano Modelo
      cdCor: veiculo.cor,  // Cor
      cdPbt: veiculo.pbt,  // PBT
      cdChassi: veiculo.chassi,  // Chassi
      nmCidade: veiculo.municipio,  // Cidade
      nmPais: veiculo.procedencia === 'Nacional' ? 'BRASIL' : 'IMPORTADO',  // País
      nmMarca: marca.trim(),  // Marca
      nmModelo: modelo.trim(),  // Modelo
    });
  }

  allowOnlyLettersAndNumbers(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (!/[A-Za-z0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  constructor(
    private serviceApiBase: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private doenload_cvs: DownloadCsv,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) { }

  public async loadVeiculo(id): Promise<void> {
    const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();
    try {
      const types = await this.serviceApiBase.get<ContentInterface[]>({
        url: "veiculo-tipo",
      });
      this.vehicleTypes = types["content"] ?? [];

      const combustiveltipo = await this.serviceApiBase.get<ContentInterface[]>(
        {
          url: "veiculo-combustivel-tipo",
        }
      );
      this.fuelTypes = combustiveltipo["content"] ?? [];

      const categoriaVeiculo = await this.serviceApiBase.get<
        ContentInterface[]
      >({
        url: "categoria-veiculo",
      });
      this.categoriaVeiculos = categoriaVeiculo["content"] ?? [];

      const params = {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      };

      const result = await this.serviceApiBase.get<any>({
        url: new Company()["nomeConsultaApiBaseGetAll"],
        params,
      });

      this.companies = result["content"] ?? [];

      const response = await this.serviceApiBase.get<Vehicle>({
        url: new Vehicle()["nomeConsultaApiBase"] + "/" + this.veiculoId,
      });

      this.veiculo = response as Vehicle;

      this.axisQuantity = this.veiculo.nrQuantidadeEixo;

      if (this.axisQuantity != null) {
        this.vehicleForm.controls["nrQuantidadeEixo"].setValue(
          this.axisQuantity
        );
      }

      if (this.veiculo.tipoRodagem != null) {
        this.vehicleForm.controls["tipoRodagem"].setValue(
          this.veiculo.tipoRodagem
        );
      }

      if (this.veiculo.idEmpresa != null) {
        if (this.veiculo.idEmpresaMatriz == null) {
          this.empresaFilterSelected = "Matriz";
        } else {
          this.empresaFilterSelected = "Filial";
        }
      } else {
        this.empresaFilterSelected = "Divisão";
      }

      this.filterCompany();

      if (this.veiculo.idEmpresa != null) {
        this.vehicleForm.controls["idEmpresa"].setValue(this.veiculo.idEmpresa);
      } else {
        this.vehicleForm.controls["idEmpresa"].setValue(this.veiculo.idDivisao);
      }

      this.fillVehicleData();
    } catch (error) {
      console.error(error);
    }
  }

  fillVehicleData(): void {
    if (this.veiculo.idEmpresa != null) {
      this.veiculo.idEmpresa = null;
    }

    if (this.veiculo.idVeiculoCombustivelTipo) {
      this.vehicleForm.controls["idVeiculoCombustivelTipo"].setValue(
        this.veiculo.idVeiculoCombustivelTipo
      );
    }
    if (this.veiculo.idVeiculoTipo) {
      this.vehicleForm.controls["idVeiculoTipo"].setValue(
        this.veiculo.idVeiculoTipo
      );
    }

    Object.getOwnPropertyNames(this.veiculo).forEach((element) => {
      if (this.vehicleForm.controls[element]) {
        this.vehicleForm.controls[element].setValue(this.veiculo[element]);
      }
    });

    this.errorDebug = getFormValidationErrors(this.vehicleForm);
  }

  public async submitForm(): Promise<void> {
    try {
      this.coverterUpperCase(this.vehicleForm);
      this.spinner.show();

      const values = this.vehicleForm.value;

      values.veiculoSensorList.forEach((valueId) => {
        valueId.id = null;
      });

      var post;

      console.log(post);

      if (this.empresaFilterSelected != "Divisão") {
        post = {
          ...values,
          veiculoTipo: { id: parseInt(values.veiculoTipo) },
          veiculoCombustivelTipo: {
            id: parseInt(values.veiculoCombustivelTipo),
          },
          empresa: {
            id: parseInt(values.idEmpresa),
          },
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      } else {
        post = {
          ...values,
          veiculoTipo: { id: parseInt(values.veiculoTipo) },
          veiculoCombustivelTipo: {
            id: parseInt(values.veiculoCombustivelTipo),
          },
          divisao: {
            id: parseInt(values.idEmpresa),
          },
          idEmpresa: null,
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      }

      await this.serviceApiBase.post<Vehicle>(
        new Vehicle()["nomeConsultaApiBase"],
        post
      );

      this.spinner.hide();

      this.router.navigate(["/consulta/VEHICLE_FUNCIONALIDADE"]);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  get veiculoSensorItems(): FormArray {
    return this.vehicleForm.get("veiculoSensorList") as FormArray;
  }

  public downloadCsv() {
    this.spinner.show();

    this.doenload_cvs.download().subscribe(
      (r) => {
        this.spinner.hide();

        let file = new Blob([r], { type: "application/csv" });
        let fileURL = URL.createObjectURL(file);

        let a = document.createElement("a");
        a.href = fileURL;
        a.download = "exemplo_lote.csv";
        a.click();
        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 800);
      },
      (error) => {
        this.spinner.hide();
        this.errorMessage = error.message;
        throw new EvalError(error);
      }
    );
  }

  public filterCompany() {
    var idEmpresa = this.empresaFilterSelected;
    this.vehicleForm.controls["idEmpresa"].setValue(null);
    var empresas = [];

    if (idEmpresa == "Divisão") {
      this.companies.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    console.log(this.companiesFilter);
  }

  public coverterUpperCase(vehicleForm: FormGroup) {
    console.log(vehicleForm);

    vehicleForm
      .get("cdPlaca")
      .setValue(vehicleForm.get("cdPlaca").value.toUpperCase());
    vehicleForm
      .get("frota")
      .setValue(vehicleForm.get("frota").value.toUpperCase());
    vehicleForm
      .get("cdChassi")
      .setValue(vehicleForm.get("cdChassi").value.toUpperCase());
    vehicleForm
      .get("cdAntt")
      .setValue(vehicleForm.get("cdAntt").value.toUpperCase());
    vehicleForm
      .get("nmMarca")
      .setValue(vehicleForm.get("nmMarca").value.toUpperCase());
    vehicleForm
      .get("nmModelo")
      .setValue(vehicleForm.get("nmModelo").value.toUpperCase());
    vehicleForm
      .get("cdCor")
      .setValue(vehicleForm.get("cdCor").value.toUpperCase());
    vehicleForm
      .get("nmCidade")
      .setValue(vehicleForm.get("nmCidade").value.toUpperCase());
    vehicleForm
      .get("nmEstado")
      .setValue(vehicleForm.get("nmEstado").value.toUpperCase());
    vehicleForm
      .get("nmPais")
      .setValue(vehicleForm.get("nmPais").value.toUpperCase());
    vehicleForm
      .get("nmNomeProprietario")
      .setValue(vehicleForm.get("nmNomeProprietario").value.toUpperCase());
  }
}
